import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../config/firebase';

export interface ContactMessage {
  id?: string;
  userId: string;
  userName: string;
  userEmail: string;
  subject: string;
  message: string;
  status: 'pending' | 'resolved';
  createdAt: Date;
  resolvedAt?: Date;
}

export const createContactMessage = async (
  userId: string,
  userName: string,
  userEmail: string,
  subject: string,
  message: string
): Promise<string> => {
  try {
    const messagesRef = collection(db, 'contactMessages');

    const newMessage = {
      userId,
      userName,
      userEmail,
      subject,
      message,
      status: 'pending',
      createdAt: serverTimestamp(),
    };

    const docRef = await addDoc(messagesRef, newMessage);
    return docRef.id;
  } catch (error) {
    console.error('Erro ao criar mensagem de contato:', error);
    throw error;
  }
};

export const getAllContactMessages = async (): Promise<ContactMessage[]> => {
  try {
    const messagesRef = collection(db, 'contactMessages');
    const q = query(messagesRef, orderBy('createdAt', 'desc'));

    const querySnapshot = await getDocs(q);
    const messages: ContactMessage[] = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      messages.push({
        id: doc.id,
        userId: data.userId,
        userName: data.userName,
        userEmail: data.userEmail,
        subject: data.subject,
        message: data.message,
        status: data.status,
        createdAt: (data.createdAt as Timestamp)?.toDate(),
        resolvedAt: data.resolvedAt ? (data.resolvedAt as Timestamp).toDate() : undefined,
      });
    });

    return messages;
  } catch (error) {
    console.error('Erro ao buscar mensagens de contato:', error);
    throw error;
  }
};

export const updateContactMessageStatus = async (
  messageId: string,
  status: 'pending' | 'resolved'
): Promise<void> => {
  try {
    const messageRef = doc(db, 'contactMessages', messageId);
    const updates: any = {
      status,
    };

    if (status === 'resolved') {
      updates.resolvedAt = serverTimestamp();
    }

    await updateDoc(messageRef, updates);
  } catch (error) {
    console.error('Erro ao atualizar status da mensagem:', error);
    throw error;
  }
};
